import { render, staticRenderFns } from "./DriverOrders.vue?vue&type=template&id=6c3d5198&scoped=true&"
import script from "./DriverOrders.vue?vue&type=script&lang=js&"
export * from "./DriverOrders.vue?vue&type=script&lang=js&"
import style0 from "./DriverOrders.vue?vue&type=style&index=0&id=6c3d5198&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3d5198",
  null
  
)

export default component.exports